// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lPMQj","tabsBox":"styles_tabsBox__1Q4YG","createButton":"styles_createButton__ilnMN"};